import angular from 'angular';
import moment from 'moment';

import adminpulse from '@/shared/utils/adminpulse';
import { emptyGuid } from '@/shared/utils/guid';
import { getPercentageColorClass } from '@/modules/relations/budgets/budgetHelpers';
angular
  .module('cloudX')
  .controller('InvoiceStreamBudgetDialogCtrl', [
    '$http',
    '$q',
    'dialogsSvc',
    'flySvc',
    '$element',
    'close',
    'stream',
    'readOnly',
    'appUrls',
    'checkSecurity',
    'checkFeature',
    invoiceStreamBudgetDialogCtrl,
  ]);

const mapBudget = data => {
  if (!data) {
    return null;
  }
  data.percentageAmount = data.budgetAmount ? (data.actualAmount || 0) / data.budgetAmount : null;
  data.percentageHours = data.budgetHours ? (data.actualHours || 0) / data.budgetHours : null;
  data.amountClass = getPercentageColorClass(data.percentageAmount);
  data.hoursClass = getPercentageColorClass(data.percentageHours);
  return data;
};

function invoiceStreamBudgetDialogCtrl(
  $http,
  $q,
  dialogsSvc,
  flySvc,
  $element,
  close,
  stream,
  readOnly,
  appUrls,
  checkSecurity,
  checkFeature,
) {
  var vm = this;
  vm.lines = [];
  vm.hasChanges = false;
  vm.years = [];
  vm.readOnly = readOnly;

  const currentYear = moment.utc().year();
  const fromYear = currentYear - 3;
  const toYear = currentYear + 1;

  const plannedMinutesByYear = {};

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };
  vm.recalcYears = function() {
    vm.years = [];
    for (let y = fromYear; y <= toYear; y++) {
      if (vm.lines && !vm.lines.some(x => x.year === y)) {
        vm.years.push(y);
      }
    }
  };

  const getPlannedHours = year => {
    const minutes = plannedMinutesByYear[year];
    return angular.isNumber(minutes) ? minutes / 60 : null;
  };

  const loadPlannedDurations = () => {
    if (!checkFeature('CapacityPlanning') || !checkSecurity('BudgetHours:r')) return $q.when([]);
    return $http
      .get(
        `${appUrls.tasks}/api/CapacityPlanning/PlannedDurationPerYear?invoiceStreamIds=${stream.id}&fromYear=${fromYear}&toYear=${toYear}`,
      )
      .then(
        ({ data }) => data || [],
        () => [],
      );
  };

  $q.all([$http.get(`${appUrls.api}/api/Budget/All/${stream.id}`), loadPlannedDurations()]).then(
    ([{ data }, plannedDurations]) => {
      plannedDurations.forEach(x => {
        plannedMinutesByYear[x.year] = x.minutes;
      });
      vm.lines = (data || []).map(mapBudget);
      vm.lines.forEach(line => {
        line.plannedHours = getPlannedHours(line.year);
      });
      vm.recalcYears();
    },
    showError,
  );

  vm.cancel = function() {
    close(vm.hasChanges, 500);
  };
  vm.saveBudget = function(line, field, data) {
    //Validation error
    if (typeof data === 'undefined') return '';
    if (angular.equals(line, data)) return false;
    var model = angular.copy(line);
    model[field] = data;
    vm.hasChanges = true;
    return $http.put(`${appUrls.api}/api/budget/`, model).then(({ data }) => {
      const newBudget = mapBudget(data);
      angular.extend(line, newBudget);
      return false;
    }, showError);
  };

  vm.deleteBudget = function(line) {
    if (!line || !line.id) return;
    if (line.id === emptyGuid) {
      var idx = vm.lines.indexOf(line);
      if (idx >= 0) vm.lines.splice(idx, 1);
      return;
    }
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgDeleteBudget').then(function() {
      line.deleting = true;
      $http.delete(`${appUrls.api}/api/Budget/${line.id}`).then(function() {
        vm.hasChanges = true;
        flySvc.success();
        var idx = vm.lines.indexOf(line);
        if (idx >= 0) vm.lines.splice(idx, 1);

        vm.recalcYears();
        return false;
      }, showError);
    });
  };

  vm.addBudget = function(year) {
    const model = {
      invoiceStreamId: stream.id,
      year,
      budgetAmount: null,
      budgetHours: null,
    };
    return $http.put(`${appUrls.api}/api/budget/`, model).then(({ data }) => {
      const newBudget = mapBudget(data);
      newBudget.plannedHours = getPlannedHours(newBudget.year);
      vm.lines.push(newBudget);
      vm.recalcYears();
      return false;
    }, showError);
  };
}
